import React, { useEffect, useRef, useState } from 'react'

import styles from './styles.module.scss'
import cn from 'classnames'
import burgerIcon from '../../assets/icons/burger.svg'
import close from '../../assets/icons/close-white.svg'
import ProfileNav from '../ProfileNav/ProfileNav'
import logo from '../../assets/icons/logo.svg'
import { useSelector } from 'react-redux'
import config from '../../constants/config'
import UserProfileMore from '../UserProfile/UserProfileMore'
import Services from '../ProfileHeader/Services/Services'
import useBillingActive from '../../hooks/useBillingActive'
import Button from '../../UI/Button/Button'
import UserProfile from '../UserProfile/UserProfile'
import { isMobileDevice } from '../../helpers/mobileDevice.helper'
import useMediaQuery from '@mui/material/useMediaQuery'

const SERVICES_CLOSE_EVENT = 'nextship:services:close-popups'
const PROFILE_ASIDE_OPEN_EVENT = 'nextship:profile-aside:open'
const PROFILE_ASIDE_CLOSE_EVENT = 'nextship:profile-aside:close'

const ProfileAside = () => {
  const { admin } = useSelector(({ authentication }) => authentication)
  const [isOpen, setIsOpen] = useState(false)
  const isHeaderProfileVisible = useMediaQuery('(orientation: landscape), (max-height: 667px)', { noSsr: true })
  const isTabletOrMobile = useMediaQuery('(max-width: 1024px)', { noSsr: true })
  const scrollYRef = useRef(0)
  const isBillingActive = useBillingActive()
  const { first_name: firstName, last_name: lastName, email } = useSelector(({ user }) => user.profile)

  const closeMenu = () => {
    setIsOpen(false)
    window.dispatchEvent(new CustomEvent(SERVICES_CLOSE_EVENT))
  }

  useEffect(() => {
    const openMenu = () => setIsOpen(true)
    const closeMenuExternal = () => closeMenu()

    window.addEventListener(PROFILE_ASIDE_OPEN_EVENT, openMenu)
    window.addEventListener(PROFILE_ASIDE_CLOSE_EVENT, closeMenuExternal)

    return () => {
      window.removeEventListener(PROFILE_ASIDE_OPEN_EVENT, openMenu)
      window.removeEventListener(PROFILE_ASIDE_CLOSE_EVENT, closeMenuExternal)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (!isTabletOrMobile) return

    const body = document.body

    if (isOpen) {
      scrollYRef.current = window.scrollY || window.pageYOffset || 0
      body.style.position = 'fixed'
      body.style.top = `-${scrollYRef.current}px`
      body.style.left = '0'
      body.style.right = '0'
      body.style.width = '100%'
      return
    }

    const savedScrollY = scrollYRef.current
    body.style.position = ''
    body.style.top = ''
    body.style.left = ''
    body.style.right = ''
    body.style.width = ''

    if (savedScrollY) {
      window.scrollTo(0, savedScrollY)
    }
  }, [isOpen, isTabletOrMobile])

  const handleToggleMenu = () => {
    if (isOpen) {
      closeMenu()
      return
    }

    setIsOpen(true)
  }

  return (
    <>
      {/* burger button – visible only on <=1024px */}
      <Button
        id='tour-step-0-mobile'
        type='button'
        aria-label='Open menu'
        className={styles.burger}
        onClick={handleToggleMenu}
      >
        {isOpen ? <img src={close} alt='close' /> : <img src={burgerIcon} alt='burger icon' />}
      </Button>

      {/* dark overlay behind drawer */}
      {isOpen && <div className={styles.overlay} onClick={closeMenu} />}

      <aside className={cn(styles.aside, { [styles.open]: isOpen, admin_active_border_left: admin?.isAdmin })}>
        <div className={styles.header}>
          <a
            href={`${config.ROOT_URL}/`}
            className={cn(styles.link_to_home, {
              [styles.link_to_home_disabled]: admin?.isAdmin,
            })}
          >
            <img src={logo} alt='small logotype' />
          </a>
          <div className={styles.user_profile}>
            <UserProfile buttonId={isMobileDevice() && isHeaderProfileVisible ? 'tour-step-6' : undefined} />
            <div className={styles.more_header_info}>
              <div className={styles.more_username}>
                {firstName} {lastName}
              </div>

              <div className={styles.more_email}> {email} </div>
            </div>
          </div>
          {/* close button – visible only on <=1024px */}
        </div>

        <div className={styles.aside_content_wrapper}>
          <div className={styles.onlyMobile}>
            <div
              id={isMobileDevice() && !isHeaderProfileVisible ? 'tour-step-6' : undefined}
              className={styles.user_profile_more_wrapper}
            >
              <UserProfileMore isAdmin={admin?.isAdmin} />
            </div>
            {isBillingActive && !admin?.isAdmin && (
              <div id='tour-step-services-mobile'>
                <Services />
              </div>
            )}
          </div>

          <div id={isMobileDevice() ? 'tour-step-1' : undefined} className={styles.navigation_list}>
            <ProfileNav onCloseMobileMenu={closeMenu} />
          </div>
        </div>
      </aside>
    </>
  )
}
export default ProfileAside
